export const EMAIL_VALIDATION_REQUEST_SOURCE = {
  MOBILE: "mobile",
  DESKTOP: "desktop",
};
